/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `cache` - CACHE * `file_system` - FILE_SYSTEM
 * @export
 * @enum {string}
 */

export const StorageMethod = {
    Cache: 'cache',
    FileSystem: 'file_system'
} as const;

export type StorageMethod = typeof StorageMethod[keyof typeof StorageMethod];



